import AutoGenerateContainer from './AutoGenerate'
export default AutoGenerateContainer
